import { combineReducers } from "redux";
import { reducer as assignees } from "./assigneeList/assigneeListSlice";
import { reducer as currentTicket } from "./currentTicket/currentTicketSlice";
import { reducer as messages } from "./messages/messageListSlice";

export default combineReducers({
  assignees,
  currentTicket,
  messages,
});
